import React from 'react';
import { ForgotPassword } from '../../../modules/forgotPassword/components/ForgotPassword/ForgotPassword';

export function ForgotPasswordPage() {
	return <ForgotPassword />;
}
